var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.meta)?_c('PageTitle',{attrs:{"title":_vm.meta.h1,"breadcrumbs":_vm.meta.breadcrumbs}}):_vm._e(),_c('DocumentsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }